"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _timeFormatting = _interopRequireDefault(require("./time-formatting"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const {
  concatMinutes,
  concatAmAndPm,
  toTimezone
} = _timeFormatting.default;

function formatTimeLabel(startDate, endDate, timezone) {
  const start = new Date(toTimezone(startDate, timezone));
  const end = new Date(toTimezone(endDate, timezone));
  const startTime = concatMinutes(start.getHours() > 12 ? `${start.getHours() % 12}` : `${start.getHours()}`, start.getMinutes());
  const endTime = concatAmAndPm(end);
  return `${startTime} - ${endTime}`;
}

function formatSlots({
  slots
}, timezone) {
  if (!slots) {
    console.log('formatSlots - slots are invalid. slots:', slots);
    return [];
  } // Get all slot dates converted to correct timezone
  // example timezones: 'Atlantic/Cape_Verde', 'America/Adak', 'Europe/Dublin'


  const formatedSlots = slots.map(slot => {
    const originalDate = slot.start;
    const start = new Date(toTimezone(slot.start, timezone));
    const hoursVal = `${start.getHours()}`.padStart(2, '0');
    const minutesVal = `${start.getMinutes()}`.padStart(2, '0');
    return {
      date: start,
      originalDate,
      optValue: `${hoursVal}${minutesVal}`,
      optLabel: formatTimeLabel(slot.start, slot.end, timezone)
    };
  }); // order all slots by start date

  const orderedSlots = formatedSlots.sort((a, b) => a.date - b.date); // group slots by date

  const groupedSlots = orderedSlots.reduce((acc, slot) => {
    const {
      date
    } = slot;
    const dateString = `${date.getDate()}-${date.getMonth()}-${date.getYear()}`;
    const slotValues = {
      optValue: slot.optValue,
      optLabel: slot.optLabel,
      originalDate: slot.originalDate
    };

    if (!(dateString in acc)) {
      return Object.assign(acc, {
        [dateString]: {
          date,
          timeSlots: [slotValues]
        }
      });
    }

    acc[dateString].timeSlots.push(slotValues);
    return acc;
  }, {});
  return Object.values(groupedSlots);
}

var _default = {
  formatTimeLabel,
  formatSlots
};
exports.default = _default;